import { Directive, ElementRef, inject, OnDestroy } from '@angular/core';
import { HelpButtonPositionerService } from './help-button-positioner.service';

@Directive({
  selector: '[appHelpButtonPositioner]',
  standalone: true,
})
export class HelpButtonPositionerDirective implements OnDestroy {
  readonly helpButtonPositionerService = inject(HelpButtonPositionerService);
  readonly elementRef = inject(ElementRef);

  private resizeObserver: ResizeObserver | undefined;
  private helpButtonStackId: number = null;

  get nativeElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    this.resizeObserver = new ResizeObserver(() => {
      if (this.nativeElement.clientWidth === 0) {
        this.helpButtonPositionerService.pop(this.helpButtonStackId);
        this.helpButtonStackId = null;
        return;
      }

      this.helpButtonStackId = this.helpButtonPositionerService.register(
        this.helpButtonStackId,
        this.nativeElement.clientWidth,
      );
    });

    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.helpButtonPositionerService.pop(this.helpButtonStackId);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}
